import React from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import {
  CardTitle,
  CardBody,
  Counter,
  CounterButton,
  Description,
  CreditAmount,
} from "./CreditAmountCounterStyles";

type CreditAmountCounterProps = {
  creditAmount: number;
  onClickCounter: (amount: number) => void;
};

const CreditAmountCounter = ({
  creditAmount,
  onClickCounter,
}: CreditAmountCounterProps) => {
  const { t } = useTranslation("my_credits");

  return (
    <div>
      <CardTitle>{t("Additional Credits")}</CardTitle>
      <CardBody>
        <span style={{ color: "#282828", marginTop: 10 }}>
          {t("Choose Amount")}
        </span>
        <br />
        <Counter>
          <CounterButton
            type="primary"
            icon={<MinusOutlined />}
            size="large"
            onClick={() => onClickCounter(-1)}
          />
          <CreditAmount>{creditAmount}</CreditAmount>
          <CounterButton
            type="primary"
            icon={<PlusOutlined />}
            size="large"
            onClick={() => onClickCounter(1)}
          />
        </Counter>
        <br />
        <Description>{t("Valid for 28 days")}</Description>
      </CardBody>
    </div>
  );
};

export default CreditAmountCounter;
